<!-- @defer (on timer(1000)) { -->
<div *ngIf="!isAuthenticated && isEditMode; else normal" class="h-full">
  @defer (on timer(7000)) {
  <div class="flex justify-center items-center w-full h-full">
    <h2 class="translate-y-[-30px]">You must visit this page from ImGoing DXP.</h2>
  </div>
  }
</div>

<ng-template #normal>

  <div *ngIf="frontendSettings && !frontendSettings.toggle.itinerary">
    <div class="w-full h-full flex items-center justify-center absolute z-[200] top-0 left-0 bg-white">
      <p class="text-gray-600 text-2xl font-semibold">Suggested Itineraries is not enabled, please contact your ITI
        support.</p>
    </div>
  </div>

  <ig-itinerary-details-modal *ngIf="isForSingleItineraryEmbed && currentItinerary" mode="embed"
    [currentItinerary]="currentItinerary"></ig-itinerary-details-modal>

  <div #backgroundDiv *ngIf="!isForSingleItineraryEmbed"
    class="bg-no-repeat bg-cover bg-bottom w-full h-full flex justify-center overflow-hidden relative"
    [class.items-center]="!isFromTripPlanner" [class.overflow-y-auto]="isFromTripPlanner && !isLoadingItineraries"
    [class.min-h-[70vh]]="isFromTripPlanner && isLoadingItineraries" [class.!justify-normal]="isStartQuiting"
    [class.!items-baseline]="isStartQuiting"
    [style.background-image]="isFromTripPlanner ? '' : 'url(&quot;' + itinerarySettings?.bgImage + '&quot;)'"
    [class.ig-iti-edit-mode]="isEditMode" [class.script-mobile]="mediaQueryService.isMobile$ | async"
    [class.script-desktop-sm]="mediaQueryService.isDesktopSm$ | async"
    [class.script-desktop-lg]="mediaQueryService.isDesktopLg$ | async"
    [class.script-desktop-xl]="mediaQueryService.isDesktopXl$ | async"
    [class.script-desktop-2xl]="mediaQueryService.isDesktop2Xl$ | async"
    [class.script-desktop-3xl]="mediaQueryService.isDesktop3Xl$ | async">

    @if (!isFromTripPlanner && isShowTravelBuddy) {
    @defer (on timer(2000)) {
    <ig-ai-buddy-place-listing></ig-ai-buddy-place-listing>
    }
    }

    <ng-container *ngIf="itinerarySettings; else loading">

      <!--      <div *ngIf="isEditMode"-->
      <!--           class="absolute z-[9999999] top-4 w-[46%] left-[27%] h-10 rounded flex justify-center items-center text-lg bg-blue-400 text-white outline-1 outline-white outline-dashed">-->
      <!--        You are now in edit mode-->
      <!--      </div>-->
      <!--      <div *ngIf="isEditMode"-->
      <!--           class="absolute z-[9999999] top-4 left-8 h-32 w-32 rounded-full flex justify-center items-center text-lg bg-blue-400 text-white font-semibold outline-4 outline-white outline-dashed">-->
      <!--        EDIT MODE!-->
      <!--      </div>-->

      @if (isFromTripPlanner) {

      <div class="w-[90%]">

        <div class="w-full text-lg font-semibold mt-6 text-gray-400">
          You Are Now Viewing Our Suggested Itineraries
        </div>

        @if (isLoadingItineraries) {
        <div class="flex items-center justify-center w-full h-full">
          <ig-spinner></ig-spinner>
        </div>
        } @else {
        <div class="mt-6 grid grid-cols-4 gap-4 mobile:grid-cols-1 ig-tp-iti-list">
          <div #itinerarycard *ngFor="let itinerary of itineraries;let i = index" (click)="enterItinerary(itinerary)"
            [attr.itinerary-id]="itinerary._id" [class.col-span-3]="i===0 && !isMobile"
            [class.aspect-square]="i && !isMobile" [class.ig-tp-iti-square-card]="i || isMobile"
            class="ig-itinerary-card group relative h-full transition-all duration-150 cursor-pointer hover:scale-[1.02]">

            <div class="flex" [class.flex-col]="i || isMobile" [class.aspect-square]="i && !isMobile">

              <ig-image [src]="itinerary.image" class="relative" cls="object-cover relative"
                [class.w-[calc(67%-8px)]]="i===0 && !isMobile" [class.!h-[50%]]="i || isMobile"></ig-image>
              <div class="bg-white ig-tp-iti-card-info overflow-hidden smallDesktop:p-1"
                [class.w-[calc(33%+8px)]]="i===0 && !isMobile" [class.h-[50%]]="i" [class.!p-6]="!i" [class.p-3]="i">
                <b class=" text-blue-500 smallDesktop:text-[13px] smallDesktop:leading-3" [class.text-[16px]]="i"
                  [class.text-lg]="!i">{{ itinerary.title }}</b>

                <p
                  class="text-sm text-gray-500 flex gap-2 smallDesktop:gap-0 smallDesktop:text-xs smallDesktop:pt-1 3xl:pt-2">
                  <mat-icon class="text-[20px] text-gray-400 smallDesktop:!h-4 smallDesktop:text-[16px]">
                    run_circle
                  </mat-icon>
                  {{ itinerary['attraction'].length }} stop{{ itinerary['attraction'].length > 1 ? 's' : '' }}
                </p>
                <p *ngFor="let custom of itinerary.customFields;let j = index"
                  class="text-sm text-gray-500 flex gap-2 smallDesktop:text-xs smallDesktop:gap-0">
                  <mat-icon class="text-[20px] text-gray-400 smallDesktop:!h-4 smallDesktop:text-[16px]">
                    looks_{{ !j ? 'one' : (j === 1) ? 'two' : (j + 1) }}
                  </mat-icon>
                  {{ custom.field }}
                </p>
              </div>
            </div>

            <div *ngIf="enteringItineraryId && (enteringItineraryId === itinerary._id)"
              class="absolute left-0 top-0 w-full h-full z-10 bg-[#ffffff82] flex justify-center items-center">
              <ig-spinner></ig-spinner>
            </div>

          </div>
        </div>
        }


      </div>

      } @else {
      <ig-itinerary-image-uploader *ngIf="isEditMode" class="absolute right-[200px] top-12"
        (onImageUploaded)="updateBgImage($event)" [initialImg]="itinerarySettings?.bgImage"
        triggerText="Background image"></ig-itinerary-image-uploader>

      <div class="w-[90vw] max-w-[2000px] h-[88vh] translate-y-[3%] rounded-3xl text-gray-200 relative"
        [style.background-color]="itinerarySettings?.bgColor">
        <div class="flex gap-2 items-center absolute top-4 right-20 z-10">
          <ig-color-picker *ngIf="!isStartEntering" [color]="itinerarySettings?.bgColor"
            (slider)="bgColorSlider($event)" (close)="updateSettings()" triggerText="Background color"
            class="hidden"></ig-color-picker>
        </div>

        <div
          class="flex h-[47%] w-full justify-center items-start px-[10%] relative flex-col mobile:h-[38%] mobile:px-[6%]"
          [class.animate-out-bottom-up]="isStartEntering">
          <div class="h-[30%]"></div>
          <div *ngIf="itinerarySettings" class="border-l-8 pl-8 animate-up-bottom mobile:pl-4 mobile:border-l-[6px]"
            [style.border-color]="itinerarySettings.title1.color || 'lightgray'">

            <h1 class="font-semibold text-[3vw] flex mobile:text-2xl" [style.color]="itinerarySettings.title1.color">{{
              itinerarySettings.title1.text }}
              <ig-text-and-color *ngIf="!isStartEntering" class="hidden relative z-50 top-[10px] left-[22px]"
                [item]="itinerarySettings.title1" (close)="updateSettings()"
                (textChange)="itinerarySettings.title1.text=$event"
                (colorSlider)="itinerarySettings.title1.color=$event"></ig-text-and-color>
            </h1>

            <h1 class="text-[5vw] ig-loukong flex 3xl:text-[90px] mobile:text-2xl"
              [style.-webkit-text-stroke-color]="itinerarySettings?.title2.color">{{ itinerarySettings.title2.text }}
              <ig-text-and-color *ngIf="!isStartEntering" class="hidden relative top-[14px] left-[18px]"
                [item]="itinerarySettings?.title2" (textChange)="itinerarySettings.title2.text=$event"
                (close)="updateSettings()" (colorSlider)="itinerarySettings.title2.color=$event"></ig-text-and-color>
            </h1>
          </div>

          <div class="flex justify-center items-center gap-2 text-center max-w-[70%] h-[30%] mx-auto relative top-[5%] leading-[25px] animate-right-in
                ig-iti-intro mobile:max-w-[90%] mobile:h-[45%] mobile:text-left mobile:mx-0 mobile:mt-4">
            <span [style.color]="itinerarySettings.intro.color"
              class="text-md lg:text-md 2xl:text-xl 3xl:text-[20px] mobile:text-[16px]">{{
              itinerarySettings.intro.text
              }}</span>

            <ig-text-and-color *ngIf="!isStartEntering" [item]="itinerarySettings.intro" inputMode="textarea"
              class="hidden relative -top-5" (textChange)="itinerarySettings.intro.text=$event"
              (close)="updateSettings()" (colorSlider)="itinerarySettings.intro.color=$event"></ig-text-and-color>
          </div>

        </div>

        <div class="relative w-full h-[50%] animate-bottom-up">
          <!--      <div class="text-center">-->
          <!--        <div class="mb-1 text-sm 2xl:text-md xl:text-lg 3xl:lg">YOU ARE NOW VIEWING</div>-->
          <!--        <div class="text-sm 2xl:text-md xl:text-lg 3xl:lg">OUR SUGGESTEED ITINERARIES</div>-->
          <!--      </div>-->

          <!-- <div *ngIf="itineraries$ | async as itineraries"
                class="flex gap-4 h-[35vh] items-center justify-center relative max-w-[90%] mx-auto">

                <div *ngIf="isNeedScroll" class="flex items-center h-full mr-[1vw] ml-2 mobile:mr-0"
                  [class.disabled-arrow]="isAtStart">
                  <div
                    class="rounded-full w-[3vw] h-[3vw] bg-[#000000c7] flex justify-center items-center cursor-pointer hover:scale-[1.08]">
                    <mat-icon class="text-[24px]" (click)="goLeft()">chevron_left</mat-icon>
                  </div>
                </div>

                <div class="max-w-[90%] mx-auto overflow-x-auto overflow-y-hidden scroll-smooth flex gap-4 p-2" h-scroll>
                  <div #itinerarycard *ngFor="let itinerary of itineraries" (click)="enterItinerary(itinerary)"
                    [attr.itineraryI-id]="itinerary._id" class="relative ig-itinerary-card transition-all hover:scale-[1.05]">
                    <ig-image [src]="itinerary.image" cls="w-[12vw] min-w-[12vw] h-[26vh] object-cover rounded-sm"></ig-image>
                    <div
                      class="ig-itinerary-card-title w-full h-4/5 absolute bottom-0 left-0 rounded-b-sm bg-gradient-to-b from-transparent to-black flex items-end px-4 py-6">
                      <p class="font-semibold">{{itinerary.title}}</p>
                    </div>
                  </div>
                </div>

                <div *ngIf="isNeedScroll" class="flex items-center max-h-[500px] ml-[1vw] mr-2 mobile:ml-0"
                  [class.disabled-arrow]="isAtEnd">
                  <div
                    class="rounded-full w-[3vw] h-[3vw] bg-[#000000c7] flex justify-center items-center cursor-pointer hover:scale-[1.08]">
                    <mat-icon class="text-[24px]" (click)="goRight()">chevron_right</mat-icon>
                  </div>
                </div>

              </div> -->


          <!--      <div *ngIf="itineraries$ | async as itineraries" [class.animate-out-up-bottom]="isStartEntering"-->
          <div *ngIf="!isLoadingItineraries; else loading" [class.animate-out-up-bottom]="isStartEntering"
            class="flex gap-4 h-[35vh] items-center justify-center relative max-w-[90%] mx-auto mobile:h-[30vh] mobile:max-w-[100%]">


            <div class="absolute top-[0vh] z-20 ig-iti-create-iti">
              <ig-create-itinerary *ngIf="isEditMode" class="" [order]="itineraries.length"
                (onCreateItinerary)="loadItineraries(true)"></ig-create-itinerary>

            </div>

            <div *ngIf="isNeedScroll" class="flex items-center h-full mr-0 ml-2 mobile:mr-0">
              <div [class.disabled-go-arrow]="isAtStart" (click)="goLeft()"
                class="rounded-full w-14 h-14 bg-[#000000c7] flex justify-center items-center cursor-pointer transition-all duration-150 hover:scale-[1.08] mobile:hidden">
                <mat-icon class="text-[24px]">chevron_left</mat-icon>
              </div>
            </div>

            <div #listContainer
              class="ig-itinerary-row max-w-[90%] mx-auto overflow-x-auto overflow-y-hidden scroll-smooth flex gap-6 py-2 px-8 mobile:px-0 mobile:gap-4"
              h-scroll>
              <div #itinerarycard *ngFor="let itinerary of itineraries;let i = index"
                (click)="enterItinerary(itinerary)" [attr.itinerary-id]="itinerary._id" class="ig-itinerary-card group relative pt-6 mt-[8vh] bg-transparent w-[12vw] min-w-[280px] xlDesktop:!mt-[0] 2xl:min-w-[280px] 3xl:min-w-[280px] h-[28vh] 2xl:h-[33vh]
                      transition-all duration-150 top-0 mobile:pt-4 mobile:h-[32vh] mobile:min-w-[260px]">

                <div (mouseenter)="hoverItineraryCard(itinerary)" (mouseout)="leaveItineraryCard()"
                  class="bg-white transition-all rounded-lg flex flex-col p-2 h-[calc(13vh+85px)] min-h-[120px] 2xl:h-[calc(13vh+95px)] mobile:h-[calc(14vh+85px)] cursor-pointer hover:scale-[1.05] outline outline-1 outline-red-300"
                  [class.!h-[calc(11vh+85px)]]="!isEditMode&&!isMobile">
                  <div class="relative">
                    <div *ngIf="enteringItineraryId && (enteringItineraryId === itinerary._id)"
                      class="absolute left-0 top-0 w-full h-full z-10 bg-[#ffffff82] flex justify-center items-center">
                      <ig-spinner></ig-spinner>
                    </div>
                    <ig-image [src]="itinerary.image" class="relative"
                      cls="h-[13vh] object-cover relative rounded-lg mobile:h-[18vh]"></ig-image>
                  </div>
                  <div class="ig-itinerary-card-title relative">
                    <div *ngIf="isEditMode" class="flex justify-between py-2">
                      <div class="text-green-600 bg-green-100 rounded text-xs px-2 py-1 font-semibold"
                        [matTooltip]="itinerary.isActive ? 'This itinerary is published' : 'This itinerary is not published'"
                        igClickStopPropagation [class.!text-red-600]="!itinerary.isActive"
                        [class.!bg-red-100]="!itinerary.isActive">{{ itinerary.isActive ? 'Published' : 'Unpublished' }}
                      </div>
                      <div class="flex gap-2 items-center" igClickStopPropagation>
                        <mat-icon class="rounded-full bg-gray-600 !flex items-center justify-center text-white"
                          matTooltip="Get link" #matMenuTrigger [matMenuTriggerFor]="menu"
                          (click)="getLink(itinerary)">link
                        </mat-icon>
                        <mat-menu #menu="matMenu" class="ig-text-color-edit !rounded-md px-6 py-2">
                          <div igClickStopPropagation>
                            <p class="font-semibold text-md !mb-2">Itinerary Link</p>

                            <b class="text-sm">For sharing
                              <mat-icon class="translate-y-2 text-gray-500 text-sm"
                                matTooltip="itinerary details will be displayed in a popup window">info
                              </mat-icon>
                            </b>
                            <p class="text-sm">{{ link }}</p>

                            <div *ngIf="!popupLinkCopied && link.startsWith('http')"
                              class="cursor-pointer underline text-blue-500 mt-1 text-sm" (click)="copy('popup')">
                              Copy to Clipboard
                            </div>
                            <div *ngIf="popupLinkCopied" class="text-blue-500 text-sm mt-1">
                              <mat-icon class="!h-4 !w-4 text-[16px] translate-y-0.5">check</mat-icon>
                              Link Copied!
                            </div>

                            <div class="text-sm mt-4 font-semibold">For embedding
                              <mat-icon class="translate-y-2 text-gray-500 text-sm" matTooltip="itinerary details view will be embedded in your
                                  page">info
                              </mat-icon>
                            </div>
                            <p class="text-sm">{{ getEmbeddingScript(itinerary) }}</p>
                            <!-- <p class="text-sm">{{ link + '&ig-mode=embed' }}</p> -->

                            <div *ngIf="!embedLinkCopied && link.startsWith('http')"
                              class="cursor-pointer underline text-blue-500 mt-1 text-sm"
                              (click)="copy('embed', itinerary)">
                              Copy to Clipboard
                            </div>
                            <div *ngIf="embedLinkCopied" class="text-blue-500 text-sm mt-1">
                              <mat-icon class="!h-4 !w-4 text-[16px] translate-y-0.5">check</mat-icon>
                              Link Copied!
                            </div>
                          </div>
                        </mat-menu>
                        <mat-icon *ngIf="isEditMode" #deleteMenuTrigger="matMenuTrigger"
                          [matMenuTriggerFor]="deleteMenu"
                          class="rounded-full bg-gray-600 !flex items-center justify-center text-white"
                          matTooltip="Delete permanently">
                          delete
                        </mat-icon>
                        <mat-menu #deleteMenu="matMenu">
                          <div class="flex items-center gap-2">
                            <mat-icon class="!w-1/3 text-center">delete</mat-icon>
                            <div class="pr-4">
                              <span class="text-sm">Are you sure you want to delete the itinerary?</span>
                              <ig-button mode="flat" class="w-full text-white rounded-xl text-center my-1"
                                cls="!p-1 mt-2 mb-1 w-full" [isAsync]="true" color="warn"
                                successText="Itinerary deleted successfully!"
                                (trigger)="deleteItinerary(itinerary, $event)" igClickStopPropagation>Delete
                              </ig-button>
                            </div>
                          </div>
                        </mat-menu>
                        <!-- <mat-icon *ngIf="isEditMode" #moreMenuTrigger="matMenuTrigger"
                            [matMenuTriggerFor]="moreItineraryOperationsMenu"
                            class="rounded-full bg-gray-600 !flex items-center justify-center text-white"
                            matTooltip="More operations">more_horiz</mat-icon>
                          <mat-menu #moreItineraryOperationsMenu="matMenu">
                            <div class="flex items-center gap-2 mx-4">
                              <div clas="flex flex-col gap-2 items-center">
                                <mat-icon class="cursor-pointer" matTooltip="Release date">schedule</mat-icon>
                              </div>
                            </div>
                          </mat-menu> -->
                      </div>
                    </div>
                    <p class="text-gray-700 text-xs max-lines-2 2xl:text-sm xl:text-xs 3xl:md"
                      [class.font-semibold]="!isEditMode" [class.py-1]="!isEditMode" [class.text-center]="!isEditMode">
                      {{ itinerary.title }}</p>
                  </div>

                </div>

                @if (isEditMode) {
                <!--                  <div-->
                <!--                    class="opacity-0 absolute flex flex-col gap-1 top-[38px] right-[10px] cursor-pointer transition-all duration-300 group-hover:opacity-100">-->
                <!--                    <div-->
                <!--                      class="flex justify-center items-center rounded-full bg-[#00000099] w-6 h-6"-->
                <!--                      (click)="deleteItinerary(itinerary)"-->
                <!--                      matTooltip="Delete permanently" igClickStopPropagation>-->
                <!--                      <mat-icon class="text-white !w-4 !h-[18px]">delete_forever</mat-icon>-->
                <!--                    </div>-->

                <!--                    <div class="flex justify-center items-center rounded-full bg-[#00000099] w-6 h-6"-->
                <!--                         matTooltip="Get link" igClickStopPropagation>-->
                <!--                      <mat-icon class="text-white !w-4 !h-[18px]">web</mat-icon>-->
                <!--                    </div>-->
                <!--                  </div>-->

                <mat-icon *ngIf="i > 0 && !isUpdatingItineraries"
                  class="text-2xl absolute bottom-[17vh] -left-[1.5rem] text-blue-500 rounded-full"
                  matTooltip="Swap itinerary" (click)="swapItinerary(i)" igClickStopPropagation>swap_horiz
                </mat-icon>
                }
              </div>

              <p #itineraryDescription
                class="absolute top-[33vh] 3xl:top-[31vh] w-[90%] left-[5%] text-center opacity-0 transition-all duration-300 overflow-y-auto
                    translate-y-5 text-sm 2xl:text-sm xl:text-sm 3xl:text-[17px] 3xl:leading-[25px] mobile:!opacity-100 mobile:max-h-[16vh] mobile:top-[30vh]"
                [style.color]="itinerarySettings?.itineraryDescription.color">
              </p>

              @if (isEditMode) {
              <!-- <p class="absolute -bottom-0 left-1/2 translate-x-[-110px] bg-white px-3 py-2 text-md 2xl:text-lg ig-iti-desc"
                [style.color]="itinerarySettings?.itineraryDescription.color">Edit itinerary description color</p> -->
              <ig-color-picker [color]="itinerarySettings.itineraryDescription.color"
                (slider)="itinerarySettings.itineraryDescription.color=$event" (close)="updateSettings()"
                triggerText="Edit itinerary description color"
                class="absolute bottom-6 left-1/2 translate-x-[164px]"></ig-color-picker>
              }
            </div>

            <div *ngIf="isNeedScroll" class="flex items-center max-h-[500px] ml-0 mr-2 mobile:ml-0">
              <div [class.disabled-go-arrow]="isAtEnd" (click)="goRight()"
                class="rounded-full w-14 h-14 bg-[#000000c7] flex justify-center items-center cursor-pointer transition-all duration-150 hover:scale-[1.08] mobile:hidden">
                <mat-icon class="text-[24px]">chevron_right</mat-icon>
              </div>
            </div>


          </div>

          <ng-template #loading>
            <div class="flex justify-center items-center w-full h-full">
              <ig-spinner></ig-spinner>
            </div>
          </ng-template>
        </div>

      </div>
      }


    </ng-container>
    <ng-template #loading>
      <div class="flex justify-center">
        <ig-spinner></ig-spinner>
      </div>
    </ng-template>
  </div>
</ng-template>
<!-- } -->